import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=6b91db73&scoped=true"
import script from "./HomeTabs.vue?vue&type=script&lang=js"
export * from "./HomeTabs.vue?vue&type=script&lang=js"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&id=6b91db73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91db73",
  null
  
)

export default component.exports